export default __webpack_public_path__ + "static/img/3.93f01f1.png";